var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompte(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.4 35.5",
    style: {
      enableBackground: "new 0 0 25.4 35.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M22.9,17.9c-1.3-1.3-3.1-2.1-5-2.1H7.3c-1.9,0-3.7,0.7-5,2.1c-1.3,1.3-2.1,3.1-2.1,5l0.6,11.1 c0,0.7,0.5,1.2,1.2,1.2h21.2c0.7,0,1.2-0.5,1.2-1.2L25,23C25,21.1,24.3,19.3,22.9,17.9z M3.2,32.9L2.7,23c0-1.2,0.5-2.4,1.4-3.3 c0.9-0.9,2.1-1.4,3.3-1.4h10.6c1.2,0,2.4,0.5,3.3,1.4c0.9,0.9,1.4,2.1,1.4,3.3L22,32.9H3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    stroke: "current",
    className: "st0",
    d: "M12.8,14.4c1.9,0,3.7-0.7,5-2.1c1.3-1.3,2.1-3.1,2.1-5c0-1.9-0.7-3.7-2.1-5c-1.3-1.3-3.1-2.1-5-2.1 c-1.9,0-3.7,0.7-5,2.1c-1.3,1.3-2.1,3.1-2.1,5c0,1.9,0.7,3.7,2.1,5C9.1,13.7,10.9,14.4,12.8,14.4z M8.1,7.3C8.1,6,8.6,4.9,9.5,4 l0,0c0.9-0.9,2.1-1.4,3.3-1.4s2.4,0.5,3.3,1.4C17,4.9,17.5,6,17.5,7.3c0,1.2-0.5,2.4-1.4,3.3C15.2,11.5,14,12,12.8,12 s-2.4-0.5-3.3-1.4C8.6,9.7,8.1,8.5,8.1,7.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompte);
export default __webpack_public_path__ + "static/media/Compte.67b66c70.svg";
export { ForwardRef as ReactComponent };